import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", Object.assign({
  viewBox: "0 0 24 25",
  fill: "currentColor",
  "aria-hidden": "true",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  d: "M3.45 17.685a.75.75 0 0 1 .75.75v3.801a.75.75 0 1 1-1.5 0v-3.801a.75.75 0 0 1 .75-.75"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M19 2.085a.75.75 0 0 1 .75.75v1.54a3.71 3.71 0 0 1 1.121 3.743l-.916 3.416.173.155.279.266.052.056a.75.75 0 0 1-.045 1.005.74.74 0 0 1-.664.209v9.011a.75.75 0 1 1-1.5 0V17.9l-.748 2.792c-.316 1.178-1.521 1.896-2.707 1.578L8.61 20.612c-1.186-.318-1.871-1.543-1.556-2.721l2.022-7.547a.75.75 0 0 1-.702-.538.75.75 0 0 1 .514-.928l.624-.157.911-3.403c.527-1.965 2.533-3.154 4.496-2.628l3.33.892v-.747a.75.75 0 0 1 .75-.75zM8.504 18.28a.717.717 0 0 0 .494.884l6.186 1.657a.716.716 0 0 0 .869-.519l.572-2.136c-1.277.152-2.644.043-3.94-.283-1.304-.329-2.572-.889-3.63-1.664zm9.746-6.199c-2.136-1.583-4.89-2.378-7.536-2.048L9.48 14.638c.938.825 2.204 1.447 3.572 1.792s2.781.4 3.999.149l1.199-4.477zM14.531 4.14c-1.144-.307-2.341.383-2.658 1.567l-.745 2.779c2.664-.186 5.352.591 7.541 2.056l.753-2.813c.317-1.184-.375-2.38-1.52-2.687z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.45 10.085a.75.75 0 0 1 .75.75v3.8a.75.75 0 0 1-1.5 0v-3.8a.75.75 0 0 1 .75-.75m0-8a.75.75 0 0 1 .75.75v3.8a.75.75 0 1 1-1.5 0v-3.8a.75.75 0 0 1 .75-.75"
}));
const ForwardRef = forwardRef(SvgComponent);
export const CarLeavingLaneIcon = ForwardRef;